export default class ValeurPropreCountComponentController {
	static $inject = ['CentreGestionService'];

	constructor(CentreGestionService) {
		this.CentreGestionService = CentreGestionService;
		this.count = 0;
	}

	async $onInit() {
		await this.getValeurPropreCount();
	}
	async $onChanges(changes) {
		if (changes.refreshKey && !changes.refreshKey.isFirstChange()) {
			this.refreshCount();
		}
	}
	async getValeurPropreCount() {
		this.startLoading();
		try {
			this.count = await this.CentreGestionService.getValeurPropreCount(this.domaine, this.id);
		} catch (error) {
			console.error(error);
		} finally {
			this.stopLoading();
		}
	}

	refreshCount() {
		this.getValeurPropreCount();
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
